import styled from "styled-components"

export const Container = styled.div`
  border-radius: ${({ dropdownBorderRadius }) => dropdownBorderRadius && dropdownBorderRadius};
  border-style: ${({ dropdownBorderStyle, activeBorder }) =>
    activeBorder && dropdownBorderStyle && dropdownBorderStyle};
  border-color: ${({ dropdownBorderColor, activeBorder }) =>
    activeBorder && dropdownBorderColor && dropdownBorderColor};
  border-width: ${({ dropdownBorderSize, activeBorder }) =>
    activeBorder && dropdownBorderSize && dropdownBorderSize};
  height: 50px;
  position: relative;
  width: 100%;
`

export const InputWrapper = styled.div`
  align-items: center;
  background-color: ${({ defaultColor }) => defaultColor || "#5588FF"};
  border-radius: inherit;
  display: flex;
  height: 100%;
  padding: 0 12px;
  gap: 8px;

  i.fa-search {
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    flex-shrink: 0;
  }
`

export const SearchInput = styled.input`
  background: transparent;
  border: none;
  color: #fff;
  flex: 1;
  font-size: 14px;
  outline: none;
  width: 100%;

  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }
`

export const ClearButton = styled.button`
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
  flex-shrink: 0;

  &:hover {
    color: #fff;
  }
`

export const SuggestionList = styled.ul`
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  list-style: none;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  padding: 4px 0;
  position: fixed;
  z-index: 99999;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ scrollBarColor }) => scrollBarColor || "#ccc"};
    border-radius: 3px;
  }
`

export const SuggestionItem = styled.li`
  cursor: pointer;
  font-size: 13px;
  padding: 8px 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover {
    background-color: #f5f5f5;
  }
`
